const FormatExtraCommission = (offer) => offer;

export default FormatExtraCommission;
